"use client"

interface CheckBoxProps {
  width?: number
  height?: number
  checked: boolean
  checkedColor: string
  border: {
    color: string
    borderWidth: string
    radius: string
  }
  onChange: (checked: boolean) => void
  checkedImage?: string
}

const CheckBox = ({ width, height, checked, checkedColor, border, onChange, checkedImage }: CheckBoxProps) => {
  return (
    <input
      type="checkbox"
      className="min-w-[20px] min-h-[20px] cursor-pointer appearance-none relative "
      checked={checked}
      onChange={() => onChange(!checked)}
      style={
        {
          "--width": width,
          "--height": height,
          borderColor: checked && checkedImage ? "transparent" : checked ? checkedColor : border.color,
          borderWidth: border.borderWidth,
          borderRadius: border.radius,
          backgroundColor: checked && !checkedImage ? checkedColor : "transparent",
          backgroundImage: checked ? `url("${checkedImage ?? "/icons/checked.svg"}")` : "none",
          backgroundPosition: "center",
          backgroundSize: checkedImage ? "18.3333px 18.3333px" : "14px 14px",
          backgroundOrigin: checkedImage ? "border-box" : undefined,
          backgroundRepeat: "no-repeat",
        } as React.CSSProperties
      }
    />
  )
}

export default CheckBox
